//example from https://appelgran.org/blog/post/46/javascript-check-if-element-and-childnodes-are-empty
export const  emptyOrEmptyHTML = function (n) {
    if (n.childNodes.length > 0) {
      for( var x = 0; x < n.childNodes.length; x++ ) {
        if (!emptyOrEmptyHTML(n.childNodes[x])) {
          return false;
        }
      }
      return true;
    }
    else {
      if (n.nodeType == 1) {
        return n.innerHTML.trim().length == 0;
      }
      else if (n.nodeType == 3) {
        return n.textContent.trim().length == 0;
      }
      else {
        return true;
      }
    }
  }




// WEBPACK FOOTER //
// ./app/javascript/rmrc_ad/util.js